export default __webpack_public_path__ + "static/media/Locked.7fb69651.svg";